// TODO: resolve CHCP disables by bot
/* eslint-disable sonarjs/no-duplicate-string */
import { ClaimSummary } from '@cigna/chcp/shared/util';
import { ClaimDetails, ClaimsSearchResponse } from './claims.model';
import { Adjustment, AdjustmentStatus } from './reconsideration.model';

export const mockClaimDetail: ClaimDetails = {
  claimCompositeKey: '1111111',
  tinNumber: '12345',
  memberObject: {
    memberId: 'string',
    memberDateOfBirth: '03/01/1980',
    memberFirstName: 'string',
    memberLastName: 'string',
    hasRestrictedAccount: true,
    hasRestrictedGroup: false,
    notes: 'string',
  },
  claimInfoObject: {
    hasReconAccess: true,
    serviceProvider: 'string',
    claimDateOfService: '03/01/2019-03/02/2019',
    coverageCompositeKey: '12323232',
    claimTotChargeAmount: '0',
    claimReferenceNumber: 'claimReferenceNumberTest',
    claimStatusDesc: 'Denied',
    uploadUrl: 'string',
    isWebster: true,
    isDOSEstimate: false,
    groupNumber: '123',
    claimEngineClaimID: 'string',
    networkPPOIndicator: 'string',
    sourceSystemCode: 'PCLM',
    firstName: 'MOGAAN',
    lastName: 'TERRY',
    ssn: '975027974',
    ami: 'U93060447',
    idCardExtensionCode: '01',
    remarkCodes: [
      {
        remarkCode: 'string',
      },
    ],
    claimDetailsInfoMessages: [
      {
        claimInfoText: 'string',
      },
    ],
    isBehavioral: true,
    claimReceivedDate: '10/22/2020',
    claimProcessedDate: '10/22/2020',
    claimDrgUsedCode: 'string',
    claimStatusCodes: [
      {
        statusCodeValue: 'string',
        statusCodeDesc: 'string',
        reasonCodeValue: 'string',
        reasonCodeDesc: 'string',
      },
    ],
    paymentInfoMessages: [
      {
        label: 'string',
        value: '$0.00',
      },
    ],
    payeePaymentInfoMessages: [
      {
        paymentInfoText: 'string',
      },
    ],
    patientResponsibility: 'string',
    claimTotPaidAmount: '0',
    paymentInfo: {
      chargeAmount: 0,
      adjustmentDueOtherInsurence: 0,
      estimate: 0,
      cignaPaidAmount: 0,
    },
    payeeInfo: [
      {
        eftExists: true,
        chkExists: false,
        paymentInfoMessage: 'string',
        payeeName: 'string',
        payeeAddress: 'string',
        checkAmount: '0',
        remittanceNumber: 'string',
        checkNumber: 'string',
        checkStatus: 'string',
        checkIssuedDate: '01/31/2004',
        checkClearedDate: '01/31/2004',
        paymentMethod: 'string',
      },
    ],
    serviceLineInfoArray: [
      {
        id: 111,
        isDOSEstimate: true,
        dateOfService: '01/31/2004',
        cdtCode: 'string',
        procedureCode: 'string',
        toothNumber: 'string',
        amountCharged: 'string',
        svcLineContractedAmount: 'string',
        svcLinePaidAmount: 'string',
        placeOfService: 'string',
        allowedAmount: 'string',
        serviceLineApcCode: 'string',
        amountNotCovered: 'string',
        deductible: 'string',
        coveredBalance: 'string',
        planCoInsurancePer: 'string',
        memberCoInsurancePer: 'string',
        memberResponsibility: 'string',
        patientCoinsuranceResponsibility: 'string',
        copay: 'string',
        remarkCode: 'string',
        propRemarkDescription: 'string',
        hraPayment: 'string',
        hsaPayment: 'string',
        fsaPayment: 'string',
        haPayment: 'string',
      },
    ],
    serviceLineTotalsObject: {
      amountChargedTotal: 'string',
      allowedAmountTotal: 'string',
      amountNotCoveredTotal: 'string',
      deductibleTotal: 'string',
      coveredBalTotal: 'string',
      contractedAmountTotal: 'string',
      coordinationBenefitTotal: 'string',
      planCoinsurancePaidTotal: 'string',
      coPayTotal: 'string',
      memberCoInsuTotal: 'string',
      memberResponseTotal: 'string',
      paidFromHATotal: 'string',
      paidFromHSATotal: 'string',
      paidFromHRATotal: 'string',
      paidFromFSATotal: 'string',
    },
    explanationOfRemarkCodes: [
      {
        remarkCode: 'string',
        remarkCodeDesc: 'string',
      },
    ],
    additionalRemarks: 'string',
    multiPendRemarkCodes: [
      {
        remarkCode: 'string',
        remarkCodeDesc: 'string',
      },
    ],
    remittanceSummaryData: {
      isNPINumber: true,
      remittanceData: [],
    },
  },
  claimDetailErrorMessage: 'string',
};

export const mockClaimDDAR = {
  isNPINumber: false,
  remittanceData: [
    {
      documentType: '',
      remittanceTrackingNumber: '601200001865',
      creationDate: '',
      paymentDate: '02/07/2019',
      processedDate: '02/07/2019',
      generatedDate: '02/07/2019',
      reportCategory: 'EXPLANATION OF PAYMENT (DDA)',
      readRemittance: false,
      taxId: '201327369',
      depositDate: '',
      depositAmount: '$252.00',
      mbrLastName: '',
      mbrFirstName: '',
      mbrDateofBirth: '01/31/2004',
      productType: 'DPPO & Indemnity',
      documentTypeStr: '',
      numberOfPages: 129,
      links: 0,
      expirationDate: '2019-10-31T10:34:41-04:00',
      dataPowerLink: '/ecmrouter/db/hcp/dddar?docid=',
      docId: '182624',
      controlStr: 'Kh4EtNr+/prfWgj47lLdUVE+0Zg2WNcdcM6X9RtJYRE=',
      ddarMaxpages: 10,
      npiList: [],
      pagesList: [],
    },
  ],
};

const userInfo = {
  id: '12345',
  firstName: 'james',
  lastName: 'smith',
};

export const mockAdjustment: Adjustment = {
  id: 'd4f6fc2c-7b28-45e6-ab75-18a5a1e1ac1f',
  claimReferenceNumber: '0431905850011',
  requestType: 'Precertication',
  extRefNum: '1234567890',
  status: 'ADJUSTED',
  precertId: 'ACDC1234598910192372',
  notes:
    "Change will not come if we wait for some other person or some other time. We are the ones we've been waiting for. We are the change that we seek.",
  contactInformation: {
    firstName: 'Dr. Anthony',
    lastName: 'Fauci',
    phone: '8604112200',
    email: 'fauci@usa.gov',
    addressLine1: '839 Allen Dr',
    addressLine2: 'Apt 1',
    city: 'Santorini',
    state: 'AZ',
    zip: '05401',
  },
  providerId: '1238900',
  providerName: 'Hiya',
  stateOfService: 'CT',
  typeOfNetwork: 'In-Network',
  notesRequired: false,
  attachmentsRequired: false,
  nonTimelyNotesRequired: false,
  nonTimelyAttachmentsRequired: false,
  processStateUrl: '/adjustment?id=1213',
  reconsiderationType: '',
  attachments: [],
  attachmentsData: [],
  choiceOne: 0,
  choiceTwo: 5,
  choiceThree: null,
  nonTimelyChoice: 1,
  createDate: '2020-03-02T12:14:50.549Z',
  createdBy: userInfo,
  updateDate: '2020-03-04T12:14:50.549Z',
  updatedBy: userInfo,
  submittedDate: '2020-03-04T12:14:50.549Z',
  submittedBy: userInfo,
  expirationTime: 0,
  claimDos: '01/20/2002',
  groupNumber: '123145',
  memberDob: '01/22/1994',
  memberId: '122132123',
  memberFirstName: 'George',
  memberLastName: 'Floyd',
  sourceSystemCode: 'PCLM',
  householdSuffix: '01',
  requesterName: 'Black Panther',
  requesterSSOId: 'malcomX',
  reviewType: 'Post-Service',
  coverageType: 'MED',
};

export const mockAdjustmentsMultipleStatus: Adjustment[] = [
  { ...mockAdjustment, status: AdjustmentStatus.ADJUSTED },
  { ...mockAdjustment, status: AdjustmentStatus.UPHELD_INSUFFICIENT_INFO },
  { ...mockAdjustment, status: AdjustmentStatus.UPHELD_SUCCESS },
];

export const mockClaimSearchReponse: ClaimsSearchResponse = {
  coverageCompositeKey: '11111',
  claimSummaryMessages: [],
  isMultiplePatients: false,
  tooManyClaims: false,
  memberList: [
    {
      memberId: '100745484',
      memberIdActual: '1111111',
      memberDateOfBirth: '03/06/1984',
      memberFirstName: 'CALY',
      memberLastName: 'JENSEN',
      hasRestrictedAccount: false,
      hasRestrictedGroup: false,
      claimSystemCode: 'string',
      relationShipCode: 'string',
      memberSearchKey: 'string',
      isPayerSolution: false,
      isSharedAdmin: false,
      notes: 'string',
      uniqueMemberKey: 'string',
    },
    {
      memberId: '100745484',
      memberIdActual: '1111111',
      memberDateOfBirth: '03/06/1984',
      memberFirstName: 'KAY',
      memberLastName: 'JENSEN',
      hasRestrictedAccount: false,
      hasRestrictedGroup: false,
      claimSystemCode: 'string',
      relationShipCode: 'string',
      memberSearchKey: 'string',
      isPayerSolution: false,
      isSharedAdmin: false,
      notes: 'string',
      uniqueMemberKey: 'string',
    },
  ],
  showDropDownLink: false,
  showCoverage: false,
  displayHideResultsLink: false,
  noRecord: false,
  isDisplayEnabled: true,
  claimSummaryList: [
    {
      claimCompositeKey: '1111',
      claimReferenceNumber: '4221908690001',
      providerGeneratedAccountNumber: 'ALL_INS_R039_0327',
      claimType: '--',
      claimStatus: 'Pending',
      dateOfService: '03/01/2019-03/02/2019',
      dateReceived: '03/27/2019',
      dateProcessed: '04/22/2019',
      chargeAmount: '$19,055.00',
      amountPaid: '0.0',
      memberResponsibility: '--',
      servicingProvider: '/MSDRGTESTPROVH',
      claimStatusCode: 'Denied',
      claimStatusCodeDetails: [
        {
          statusCode: 'F2',
          statusCodeDesc: 'Finalized/Denial-The claim/line has been denied.   ',
        },
      ],
    },
  ],
};

export const mockClaimResults: ClaimSummary[] = [
  {
    claimCompositeKey: '1111',
    claimReferenceNumber: '1811M0022200',
    providerGeneratedAccountNumber: 'string',
    claimType: 'dated Service',
    claimStatus: 'Paid',
    dateOfService: '07/06/2019',
    dateReceived: '10/30/2019',
    dateProcessed: '11/20/2010',
    chargeAmount: '400.0',
    amountPaid: '41.0',
    memberResponsibility: '0.0',
    servicingProvider: 'MALU MARA',
    claimStatusCode: 'Paid',
    claimStatusCodeDetails: [
      {
        statusCode: 'A2',
        statusCodeDesc:
          'Acknowledgement/Acceptance into adjudication system-The claim/encounter has been accepted into the adjudication system.',
      },
      {
        statusCode: 'A1',
        statusCodeDesc:
          'Acknowledgement/Acceptance into adjudication system-The claim/encounter has been accepted into the adjudication system.',
      },
    ],
  },
  {
    claimCompositeKey: '111111',
    claimReferenceNumber: '1811M0022201',
    providerGeneratedAccountNumber: 'string',
    claimType: 'string',
    claimStatus: 'Processed',
    dateOfService: '07/05/2018',
    dateReceived: '--',
    dateProcessed: '11/29/2018',
    chargeAmount: '40.0',
    amountPaid: '41.0',
    memberResponsibility: '0.0',
    servicingProvider: 'MALU MARA',
    claimStatusCode: 'Processed',
    claimStatusCodeDetails: [
      {
        statusCode: 'P1',
        statusCodeDesc:
          'Pending/In Process-The claim or encounter is in the adjudication system. ',
      },
      {
        statusCode: 'P2',
        statusCodeDesc:
          'Pending/In Process-The claim or encounter is in the adjudication system. ',
      },
    ],
  },
];
